import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useSaveImageIntellMutation = () => {
  return useMutation<
    { id: string },
    AxiosError<any>,
    {
      files: File[];
      engine_type: string
    }
  >(
    ({ files, engine_type }) => {
      const body = new FormData();
      body.append("engine_type", engine_type)
      for (let i = 0; i < files.length; i++) {
        body.append("files", files[i]);
      }

      return axiosClient
        .post(`/image-intell/save`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 5 * 60 * 1000, // min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
